<p-toast></p-toast>
<p-dialog *ngIf="displayModal" header="Invoice" [(visible)]="displayModal" [modal]="true" [style]="{width: '50vw'}">
    <p class="p-m-0">
        <p-button icon="pi pi-check" (click)="print()" label="Print" styleClass="p-button-text"></p-button>
    <div *ngIf="success!=null && success==true">
        <div class="spaces"></div>
        <app-invoicedetails class="notranslate" [data]='fetched' [dataId]=showInvoice></app-invoicedetails>
    </div>
</p-dialog>
<div *ngIf="success!=null && success==true">
    <div class="spaces"></div>
    <app-invoicedetails class="notranslate" [data]='fetched' [dataId]=printContent></app-invoicedetails>
</div>
<div class="ui-g ui-fluid">
    <div class="ui-g-12">
        <!-- Left Side -->
        <div class="card card-w-title">

            <div class="ui-g form-group">
                <div class="ui-md-2">
                    <label><b>Transaction Type</b></label>
                    <p-dropdown id="dropdown" [disabled]="this.posting" [options]="consultations"
                        [(ngModel)]="query.consultation_type_id" (onChange)="GetTransactions(null)" [filter]="true"
                        [filterBy]='"label"'>
                    </p-dropdown>
                </div>
                <div class=" ui-md-2">
                    <label><b>Country</b></label>
                    <p-dropdown class="notranslate" id="dropdown" [disabled]="this.posting" [options]="countries"
                        [(ngModel)]="this.query.country_id" (onChange)="GetTransactions(null)" [filter]="true"
                        [filterBy]='"label"'>
                    </p-dropdown>
                </div>
                <div class=" ui-md-2">
                    <label><b>Transaction Status</b></label>
                    <p-dropdown id="dropdown" [disabled]="this.posting" [options]="status_list"
                        [(ngModel)]="this.query.status" (onChange)="GetTransactions(null)" [filter]="true"
                        [filterBy]='"label"'>
                    </p-dropdown>
                </div>
                <div class=" ui-md-2" style="padding-top: 30px;">
                    <p-checkbox [(ngModel)]="disabledDates" [disabled]="this.posting"
                        (onChange)="query.from_date=null; query.to_date=null; GetTransactions(null);"
                        [binary]="true"></p-checkbox>
                    <label style="padding-left:3px;font-style:bold">Disable Dates?</label>
                </div>
                <div class="ui-md-4"></div>
                <div class="ui-md-2">

                    <label><b>From:</b></label>
                    <p-calendar class="notranslate" [showIcon]="true" [disabled]="disabledDates ||this.posting"
                        [maxDate]="this.maxDate" placeholder="dd/mm/yyyy" dateFormat="dd/mm/yy" [monthNavigator]="true"
                        [yearNavigator]="true" yearRange="1900:2099" [(ngModel)]="query.from_date"
                        (ngModelChange)="GetTransactions(null)"></p-calendar>
                </div>
                <div class="ui-md-2">
                    <label><b>To:</b></label>
                    <p-calendar [showIcon]="true" class="notranslate" [disabled]="disabledDates || this.posting"
                        [minDate]="query.from_date" [maxDate]="this.maxDate" placeholder="dd/mm/yyyy"
                        dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2099"
                        [(ngModel)]="query.to_date" (ngModelChange)="GetTransactions(null)"></p-calendar>
                </div>
                <div class="ui-md-4" style="padding-top: 30px;">
                    <p-progressSpinner [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle'}"
                        *ngIf="this.posting" strokeWidth="6"></p-progressSpinner>
                    <button pButton type="submit" label="Reset" [disabled]="this.posting"
                        style="margin-bottom:10px;margin-right:5px;width:190px;"
                        (click)="this.InitFilter(true)"></button>
                </div>
                <div class="ui-md-12" style="color: red;" *ngIf="ErrorMessage">
                    <p>{{ErrorMessage}}</p>
                </div>
                <div class="ui-md-12" style="color: red;" *ngIf="invalid_date_message">
                    <p>Please select the From date and To date</p>
                </div>
            </div>
        </div>

    </div>
</div>
<div class="card card-w-title">
    <div class="table-responsive text-center justify-content-center"
        style="font-size:14px; margin-bottom: 20px;text-align: center;vertical-align: center;">
        <p-table #patients [value]="PatientAccount" [scrollable]="true" dataKey="id" styleClass="p-datatable-customers"
            [loading]="this.loading" [lazy]="true" [rows]="this.query.records_per_page" [totalRecords]="total_records"
            (onLazyLoad)="GetTransactions($event)" [paginator]="true" [showCurrentPageReport]="true" [scrollable]="true"
            [(first)]="this.query.first" [scrollable]="true" [autoLayout]="true" [rowsPerPageOptions]="[10,25,50]"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 70px;" pSortableColumn="sr_no"><b>Sr No</b></th>

                    <th pSortableColumn="name"><b>Patient Name</b></th>

                    <th pSortableColumn="medical_record_number"><b>MRN</b></th>

                    <th pSortableColumn="created_at"><b>Date</b></th>

                    <th pSortableColumn="country_name"><b>Country</b></th>

                    <th pSortableColumn="consultation_name"><b>Transaction Type</b></th>

                    <th pSortableColumn="transaction_no"><b>Transaction Number</b></th>

                    <th pSortableColumn="status"><b>Transaction Status</b></th>

                    <th pSortableColumn="status"><b>Consultation Status</b></th>

                    <th pSortableColumn="rendered_amount"><b>Actual Amount</b></th>

                    <th pSortableColumn="rendered_amount"><b>Paid Amount</b></th>

                    <th><b>Refund</b></th>

                    <th pSortableColumn="invoice" style="width: 100px;"><b>Invoice</b></th>

                    <th pSortableColumn="payment" style="width: 100px;"><b>Payment Details</b></th>


                </tr>

            </ng-template>
            <ng-template pTemplate="body" let-trans>
                <tr [pSelectableRow]="trans">
                    <td style="width: 70px;">
                        {{trans.sr_no}}
                    </td>
                    <td>
                        <span class="notranslate">{{trans.name}}</span>
                    </td>
                    <td>
                        <span class="notranslate">{{trans.medical_record_number}}</span>
                    </td>
                    <td>
                        <span class="notranslate">{{trans.created_at | date: 'medium'}}</span>
                    </td>
                    <td>

                        <span class="notranslate">{{trans.country_name}}</span>
                    </td>
                    <td>

                        <span>{{trans.consultation_name}}</span>
                    </td>
                    <td>

                        <span class="notranslate">{{trans.transaction_no}}</span>
                    </td>
                    <td>

                        <span>{{trans.status}}</span>
                    </td>
                    <td>

                        <span>{{trans.con_status}}</span>
                    </td>
                    <td>

                        <span class="notranslate">{{trans.rendered_actual_amount}}</span>
                    </td>
                    <td>

                        <span class="notranslate">{{trans.rendered_amount}}</span>
                    </td>
                    <td>
                        <span *ngIf="trans.status=='COMPLETE'; 
                            else not_availaible">
                            <p-button type="button" (click)="refundDialogAction(trans.id,true,trans.status)"
                                label="Refund"></p-button>
                        </span>
                        <ng-template #not_availaible>
                            N/A
                        </ng-template>
                    </td>
                    <td style="width: 100px;">
                        <span *ngIf="trans.invoice==null">Failed</span>
                        <p-button *ngIf="trans.invoice!=null" type="button" [style]="{'margin-right':'5px'}"
                            label="Print" type="button" (click)="printi(trans.id)"></p-button>
                    </td>
                    <td style="width: 100px;">
                        <span *ngIf="trans.invoice==null">Failed</span>
                        <p-button *ngIf="trans.invoice!=null" type="button" [style]="{'margin-right':'5px'}"
                            label="Open" icon="pi pi-search" type="button"
                            (click)="findPaymentInfo(trans.payment_id,trans.payment_gateway)"></p-button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="4">No Data found.</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft">
            </ng-template>
            <ng-template pTemplate="paginatorright">
            </ng-template>
        </p-table>
        <div class="row container justify-content-center text-center alert alert-danger"
            *ngIf="response.success!=null && response.success==false">
            <p *ngIf="response.error!=null">{{response.error.message}}</p>
            <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
                <p *ngFor="let message of serverError?.message">{{message}}</p>
            </div>
            <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
                <p>{{serverError?.message}}</p>
            </div>

        </div>
    </div>
</div>
<ng-container *ngIf="display1">
    <p-dialog [(visible)]="display1" id="print-content" [style]="{width: '80%' , height: '80%'}">
        <app-invoicef class="notranslate" [transaction_id]='inv_transaction_id'></app-invoicef>
    </p-dialog>
</ng-container>
<p-dialog header="Refund a Transaction" [(visible)]="refund_dialog" *ngIf="refund_dialog"
    (onHide)="refundDialogAction(null,false)" [style]="{width: '50vw'}">
    <form accept-charset="UTF-8" #refundForm="ngForm" (ngSubmit)="refund(refundBody)">
        <div class="ui-g">
            <h4>Refund Type</h4>
            <br>
            <div class="ui-g-12 ui-md-4" style="width:30%">
                <p-radioButton name="partial" #partial="ngModel" [value]="true" [(ngModel)]="refundBody.is_auto"
                    required></p-radioButton>
                <label for="approve"> Automatic calculation of refund amount</label>
            </div>
            <div class="ui-g-12 ui-md-4" style="width:30%">
                <p-radioButton name="partial" #partial="ngModel" [value]="false" [(ngModel)]="refundBody.is_auto"
                    required></p-radioButton>
                <label for="reject"> Manually enter the refund percent</label>
            </div>

            <div *ngIf="(partial.invalid && (partial.dirty || partial.touched))" class="alert alert-danger">
                <div *ngIf="partial.errors.required" class="invalid">
                    Please select a Refund Type.
                </div>
            </div>
        </div>
        <div *ngIf="refundBody.is_auto==false">
            <h4>Refund Percent</h4>
            <input type="number" name="refund_percent" #refund_percent="ngModel" pInputText
                [(ngModel)]="refundBody.refund_percent" [required]="refundBody.is_auto">
            <div *ngIf="(refund_percent.invalid && (refund_percent.dirty || refund_percent.touched)) "
                class="alert alert-danger">
                <div *ngIf="refund_percent.errors.required" class="invalid">
                    Refund Percent is Required.
                </div>
            </div>
        </div>
        <h4>Reason for Refund</h4>
        <textarea rows="5" cols="30" maxlength="1000" name="reason" #reason="ngModel" placeholder="Enter the reasons"
            [(ngModel)]="refundBody.refund_reason" required pInputTextarea></textarea>
        <div *ngIf="(reason.invalid && (reason.dirty || reason.touched))" class="alert alert-danger">
            <div *ngIf="reason.errors.required" class="invalid">
                Refund reason is required
            </div>
        </div>
        <button type="submit" pButton label="Submit" icon="pi pi-check"
            [disabled]="!refundForm.valid || posting"></button>
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="posting" strokeWidth="6">
        </p-progressSpinner>
        <div class="row container justify-content-center text-center alert alert-danger"
            *ngIf="response.success!=null && response.success==false">
            <p *ngIf="response.error!=null">{{response.error.message}}</p>
            <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
                <p *ngFor="let message of serverError?.message">{{message}}</p>
            </div>
            <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
                <p>{{serverError?.message}}</p>
            </div>
        </div>
    </form>
</p-dialog>
<p-dialog header="Payment information" *ngIf="payment.dialog" [(visible)]="payment.dialog"
    (onHide)="payment.dialog=false" [style]="{width: '50vw'}">
    <p><b>Payment Gateway</b>: {{payment.payment_method}}</p>
    <p *ngIf="payment.payment_method!='stripe'"><b>Status</b>: {{payment.status}}</p>
    <div *ngIf="payment.payment_method=='paypal'">
        <p><b>Braintree Processor Response Text</b>: {{payment.braintree_processor_response_text}}</p>
        <p><b>Braintree Transaction Status</b>: {{payment.braintree_transaction_status}}</p>
    </div>
    <div *ngIf="payment.payment_method=='razorpay'">
        <p><b>Method</b>: {{payment.method}}</p>
    </div>
    <div *ngIf="payment.payment_method=='stripe'">
        <p><b>Method</b>: {{payment.method}}</p>
    </div>
</p-dialog>